import { render, staticRenderFns } from "./CanBan.vue?vue&type=template&id=6a0831f4&scoped=true&"
import script from "./CanBan.vue?vue&type=script&lang=js&"
export * from "./CanBan.vue?vue&type=script&lang=js&"
import style0 from "./CanBan.vue?vue&type=style&index=0&id=6a0831f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0831f4",
  null
  
)

export default component.exports